export default __webpack_public_path__ + "static/media/close.33e396cb.svg";